import '../styles.css';
import { prop } from '@ipfabric/utils/fp/prop';
import { GraphBreadcrumbContainer } from 'components/Graph/GraphBreadcrumbs/GraphBreadcrumbContainer';
import type { GraphBreadcrumbProps } from 'components/Graph/GraphBreadcrumbs/GraphBreadcrumbProps';
import type { IntentCheckBreadcrumb } from 'components/Graph/GraphBreadcrumbs/helpers/buildBreadcrumbs';
import { useGraphContextSelectors } from 'components/Graph/GraphContext';
import { checkIntent } from 'components/Graph/commands/checkIntent';
import { showSidePanel } from 'components/Graph/commands/showSidePanel';
import { useLocale } from 'containers/App/LocaleContext';
import type { FC } from 'react';
import type { AppTranslations } from 'translations/translations';

export const getIntentCheckBreadcrumbText = (
  breadcrumb: IntentCheckBreadcrumb,
  msg: AppTranslations,
): string =>
  `${msg.canvasGraph.breadcrumbs.intentCheck.label} > ${breadcrumb.ruleName}`;

export const IntentCheckBreadcrumbItem: FC<
  GraphBreadcrumbProps<IntentCheckBreadcrumb>
> = (props) => {
  const msg = useLocale();

  const ctxProps = useGraphContextSelectors({
    dispatch: prop('dispatch'),
  });

  return (
    <GraphBreadcrumbContainer
      containerStyle='extra'
      onClick={() => {
        ctxProps.dispatch(showSidePanel, { contentId: 'intentVerification' });
      }}
      onRemoveButtonClick={() => {
        ctxProps.dispatch(checkIntent, { intentRule: null });
      }}
      removalIndicated={props.removalIndicated}
    >
      {getIntentCheckBreadcrumbText(props.content, msg)}
    </GraphBreadcrumbContainer>
  );
};
